import React, { useEffect, useRef, useState } from "react";
import { profilePhotoUrl } from "../../helper/image";

const FALLBACK = "/images/svg/vector.svg";

// `file` + `onSelect` make the photo editable (the picked file is previewed, saved by the parent)
function ProfilePhoto({ user, size = 96, file, onSelect, error }) {
  const inputRef = useRef(null);
  const editable = typeof onSelect === "function";
  const url = profilePhotoUrl(user);
  const [failed, setFailed] = useState(false);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    setFailed(false);
  }, [url]);

  useEffect(() => {
    if (!file) {
      setPreview("");
      return undefined;
    }
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const handlePick = (e) => {
    const picked = e.target.files?.[0];
    e.target.value = "";
    if (picked) onSelect(picked);
  };

  return (
    <div className="d-flex flex-column align-items-center mb-4">
      <img
        src={preview || (url && !failed ? url : FALLBACK)}
        alt="Profile"
        width={size}
        height={size}
        onError={() => setFailed(true)}
        style={{ borderRadius: "50%", objectFit: "cover", border: "1px solid #dee2e6" }}
      />
      {editable && (
        <>
          <input ref={inputRef} type="file" accept="image/*" hidden onChange={handlePick} />
          <div className="d-flex align-items-center gap-2 mt-2">
            <button type="button" className="btn btn-outline-light btn-sm" onClick={() => inputRef.current?.click()}>
              {file ? "Choose another" : "Change Photo"}
            </button>
            {file && (
              <button type="button" className="btn btn-outline-light btn-sm" onClick={() => onSelect(null)}>
                Undo
              </button>
            )}
          </div>
          {error && <small className="text-danger mt-1">{error}</small>}
        </>
      )}
    </div>
  );
}

export default ProfilePhoto;
